<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="card">
                    <div class="card-header">
                        {{ $t('auth.reset_password.header') }}
                    </div>

                    <div class="card-body">
                        <validation-errors :errors="errors" v-if="errors" />
                        <form-status :status="status" v-if="status" />

                        <form @submit.prevent="handleReset">
                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">{{ $t('auth.email_address') }}</label>

                                <div class="col-md-6">
                                    <input id="email" type="email" class="form-control" name="email" value="" required autocomplete="email" autofocus ref="email" v-model="email">
                                </div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-4">
                                    <button type="submit" class="btn btn-primary" :disabled="loading">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                        {{ $t('auth.reset_password.send_link_submit') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ValidationErrors from '@components/ValidationErrors';
    import FormStatus from '@components/FormStatus';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import backofficeMapsRepository from '@repositories/BackofficeMapsRepository';

    export default {
        components: {
            ValidationErrors,
            FormStatus,
        },

        data() {
            return {
                email: '',
                errors: [],
                status: null,
                loading: false,
            };
        },

        mounted() {
            this.$nextTick(() => {
                this.$refs.email.focus();
            });
        },

        methods: {
            handleReset() {
                this.loading = true;
                //use backofficeRepository.requestResetClientPassword method
                //to send a password reset link to the user's email
                backofficeRepository.requestResetClientPassword(this.email)
                    .then(() => {
                        this.status = this.$t('auth.reset_password_success');
                        this.email = '';
                    })
                    .catch((error) => {
                        this.errors = backofficeMapsRepository.parseAPIErrors(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>
